<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <!-- Review nudge strip -->
    <div class="review-strip">
      <div class="container review-strip-inner">
        <div class="review-strip-text">
          <span class="review-stars" aria-hidden="true">★★★★★</span>
          <span class="review-strip-label">Happy with our work? Leave us a Google review —</span>
          <router-link to="/review" class="review-strip-link">it only takes 60 seconds</router-link>
        </div>
        <a
          href="https://g.page/r/CZrmDpkL8T8HEBM/review"
          target="_blank"
          rel="noopener noreferrer"
          class="review-strip-qr"
          aria-label="Scan to leave a Google review"
        >
          <img src="/beastmode-qr-web.png" alt="QR code for Google review" class="footer-qr-img" />
        </a>
      </div>
    </div>

    <div class="container">
      <nav>
        <ul>
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/gallery">Gallery</router-link></li>
          <li><router-link to="/contactus">Contact Us</router-link></li>
          <li><router-link to="/aboutus">About Us</router-link></li>
          <li><router-link to="/review">Leave a Review</router-link></li>
        </ul>
      </nav>
      <div class="copyright">
        © {{ year }}, Designed by
        <a href="https://www.foundryintegrations.com" target="_blank" rel="noopener">Foundry Integrations</a>.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.footer {
  padding: 0 0 20px;
}

/* ── Review strip ── */
.review-strip {
  background: #1a1a1a;
  border-top: 3px solid #c0392b;
  padding: 16px 0;
  margin-bottom: 24px;
}

.review-strip-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.review-strip-text {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.review-stars {
  color: #f4c430;
  font-size: 1.1rem;
  letter-spacing: 2px;
}

.review-strip-label {
  font-size: 0.9rem;
  color: rgba(255,255,255,0.75);
}

.review-strip-link {
  font-size: 0.9rem;
  font-weight: 700;
  color: #c0392b !important;
  text-decoration: underline;
  white-space: nowrap;
}

.review-strip-link:hover {
  color: #e74c3c !important;
}

.review-strip-qr {
  flex-shrink: 0;
}

.footer-qr-img {
  width: 64px;
  height: 64px;
  image-rendering: pixelated;
  border: 3px solid #fff;
  border-radius: 4px;
  display: block;
}

/* Hide QR on small screens */
@media (max-width: 576px) {
  .review-strip-qr {
    display: none;
  }
  .review-strip-inner {
    justify-content: center;
    text-align: center;
  }
}

/* ── Standard footer ── */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

nav ul li {
  margin: 0 15px;
}

.copyright {
  margin-top: 15px;
  text-align: center;
}

@media (max-width: 768px) {
  nav ul {
    flex-direction: column;
    align-items: center;
  }
  nav ul li {
    margin: 10px 0;
  }
  .copyright {
    margin-top: 20px;
  }
}
</style>